import { Component, NgModule, Input, Output, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxButtonModule } from 'devextreme-angular/ui/button';
import { DxToolbarModule } from 'devextreme-angular/ui/toolbar';
import { UserPanelModule } from '../../user-panel/user-panel.component';
import { ApiService } from '../../../services/api.service';
import { DxButtonGroupModule, DxCheckBoxModule, DxFormComponent, DxFormModule, DxMapModule, DxPopupModule, DxScrollViewModule, DxTextAreaModule, DxValidatorModule } from 'devextreme-angular';
import { BrowserModule } from '@angular/platform-browser';
import { AuthService } from '../../../services';
import { IPPP, PPPPohvala } from 'src/app/shared/models/ppp.model';
import notify from 'devextreme/ui/notify';
import { GooglePlaceDirective, GooglePlaceModule } from 'ngx-google-places-autocomplete';

@Component({
  selector: 'add-pohvala-form',
  templateUrl: 'add-pohvala-form.component.html',
  styleUrls: ['./add-pohvala-form.component.scss']
})

export class AddPohvalaFormComponent implements OnInit {
  @ViewChild("addPohvalaForm", { static: false }) addPohvalaForm: DxFormComponent;
  mapMarkers = [];
  keys={};

  @ViewChild("placesRef") placesRef : GooglePlaceDirective;

  @Input()
  isPopupVisible: boolean = false;
  @Input()
  partnerId!: number;
  
  @Output() openModalChange = new EventEmitter<boolean>();
  @Output() pohvalaCreated = new EventEmitter<boolean>();
  
  pohvala: IPPP;

  constructor(
    private _api: ApiService,
    private _authService: AuthService,
  ) {
  }

  ngOnInit(): void {
    this.initPohvalaValues();
  }

  initPohvalaValues(){
    this.pohvala = new PPPPohvala();
  }

  refresh() {
    this.addPohvalaForm.instance.resetValues();
  }

  closePopup(): void {
    this.refresh();
    this.initPohvalaValues();
    this.openModalChange.emit(false);
  }

  openPopup(): void {
    this.openModalChange.emit(true);
  }

  form_fieldDataChanged (e) {
    let updatedField = e.dataField;
    let newValue = e.value;
  }

  onShown(e){
    this.addPohvalaForm.instance.getEditor("pr_naziv").focus();
  }

  onFormSubmit(e: any){
    e.preventDefault();
    this.submitForm();
  }

  submitForm(){
    this.dodajPohvalu();
  }

  dodajPohvalu(){
    const request = this.buildRequestFormData();
    this._api.dodaj3P(request).subscribe(res=>{
      if(res.success == true){
        notify("Uspješno ste dodali pohvalu!", "success", 1000);
        this.closePopup();
        this.pohvalaCreated.emit(true);
      } else {
        notify("Greška prilikom dodavanja pohvale!", "error", 1000);
      }
    });
  }

  buildRequestFormData(){
    let formData:FormData = new FormData();
    formData.append('naziv', this.pohvala.pr_naziv);
    formData.append('opis', this.pohvala.pr_opis);
    formData.append('adresa', this.pohvala.pr_adresa);
    formData.append('vrsta', this.pohvala.pr_vrsta.toString());
    formData.append('lat', '1');
    formData.append('lon', '1');
    formData.append('idproblem', '4');
    formData.append('idgost', null);
    formData.append('idpartner', this._authService.getUserPartnerId().toString());
    formData.append('datoteka', null);
    formData.append('access_token', this._authService.getToken().toString());
    return formData;
  }

}

@NgModule({
  imports: [
    BrowserModule,
    CommonModule,
    DxButtonModule,
    UserPanelModule,
    DxToolbarModule,
    DxPopupModule,
    DxFormModule,
    DxScrollViewModule,
    DxButtonGroupModule,
    DxCheckBoxModule,
    DxValidatorModule,
    DxTextAreaModule,
    DxMapModule,
    GooglePlaceModule
  ],
  declarations: [ AddPohvalaFormComponent ],
  exports: [ AddPohvalaFormComponent ]
})
export class AddPohvalaFormComponentModule { }
